import { styled } from '@mui/system'
import { Box, Grid, TextField, FormControlLabel, Button } from '@mui/material'
import logo from 'images/farmtrx-logo.png'
import { useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { closeModal, shouldShowDashboard } from 'actions/app'

const welcomeScreenImg = `${WIZARD_ASSETS_BASE_URL}/welcome-screen-harvester.png`

export default function WelcomeScreen() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [farmName, setFarmName] = useState('')
  const userDetails = useSelector((state) => state.account.user)
  const permissions = useSelector((state) => state.account.permissions)
  const onboardingTenantCreated = useSelector(
    (state) => state.app.onboardingTenantCreated,
  )
  const [showPermissions, setShowPermissions] = useState({})

  useEffect(() => {
    setShowPermissions({
      skipWizard: permissions.includes('tenant:list'),
    })
  }, [permissions])

  const handleSkipWizard = () => {
    dispatch(closeModal())

    dispatch(shouldShowDashboard())
    localStorage.setItem('wizardActiveStep', null)
  }

  const navigateToRegWizardStepper = useCallback(() => {
    if (userDetails?.tenantId) {
      localStorage.setItem(
        'wizardFarmName',
        JSON.stringify({ tenantId: userDetails.tenantId, farmName }),
      )
    }
    navigate('/wizardStepper', { state: { farmName } })
  })

  const handleInputChange = useCallback((e) => {
    setFarmName(e.target.value)
  })

  const farmId = useSelector((state) => state.farm.singleton?.id)

  // Only auto-redirect to wizard if this is a new tenant onboarding flow
  // For existing tenant users, welcome screen should be explicitly navigated to
  useEffect(() => {
    if (onboardingTenantCreated && farmId) {
      navigate('/wizardStepper')
    }
  }, [farmId, onboardingTenantCreated])

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid size={{ sm: 7, md: 6, lg: 6 }}>
          <Box
            sx={{
              mx: 3,
              my: 4,
            }}
          >
            <Box
              sx={{
                mx: 10,
                my: 12,
              }}
            >
              <img width="180" height="30" src={logo} />
            </Box>
            <Box
              sx={{
                mx: 10,
                my: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid size={{ md: 12, lg: 12 }}>
                  <h1>
                    <b>{t('welcome')}</b>
                  </h1>
                </Grid>
                <Grid size={{ md: 12, lg: 12 }}>
                  <FormControlLabel
                    sx={{ alignItems: 'flex-start', width: '100%' }}
                    control={
                      <TextField
                        style={{ width: '100%', marginTop: '16px' }}
                        name={t('farm_name')}
                        variant="outlined"
                        size="small"
                        placeholder={t('enter_farm_name_ph')}
                        value={farmName}
                        onChange={(e) => handleInputChange(e)}
                      ></TextField>
                    }
                    label={t('enter_farm_name_label')}
                    labelPlacement="top"
                  />
                </Grid>
                <Grid size={{ md: 12, lg: 12 }}>
                  <Box
                    sx={{
                      my: 18,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={
                          !farmName || farmName == '' || farmName == null
                        }
                        sx={{ borderRadius: '25px' }}
                        fullWidth
                        onClick={navigateToRegWizardStepper}
                      >
                        {t('continue_setup')}
                      </Button>
                      {showPermissions.skipWizard ? (
                        <Button color="primary" onClick={handleSkipWizard}>
                          {t('skip')}
                        </Button>
                      ) : null}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ sm: 5, md: 6, lg: 6 }}>
          <Box>
            <StyledImg src={welcomeScreenImg} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

const StyledImg = styled('img')({
  width: '49vw',
  height: '99vh',
})
